// Arrière-plan dédié à la page Portfolio — halo ember/bleu qui respire,
// rayons diagonaux très discrets façon light-leak, grain pellicule.
// Voir les classes .portfolio-bg / .portfolio-bg__rays dans index.css.
// (Home garde son propre traitement de hero via HeroOverlay.)
const PortfolioBackground = () => {
  return (
    <div className="portfolio-bg" aria-hidden="true">
      <div className="portfolio-bg__rays" />
    </div>
  );
};

export default PortfolioBackground;
